import {submitFormData, submitJsonData, submitMultipartFormData} from "../../redare/utils/Request";

/**
 * Created by RdevPlugins.JsPresenterBuilderAction on 2021-11-23 10:13:03.
 */

/**
 * @param body: {accountId, platform, userPlatform, pwd, needResetPwd}
 * @param query: {}
 * @returns Promise
 */
export function modifyPwd(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/forget/modifyPwd',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

